import React, { useState } from "react";

import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

import { IconStateSecurity } from "@/assets/icons/figma/IconStateSecurity";
import { useStorage } from "@/common/hooks/storage.hooks";
import { Button } from "@/ui/cva/Button";
import { Body } from "@/ui/typography/Body";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import Modal from "@whoppah/ui/Modal2";

export const MISSING_PAYMENT_INFO_STORAGE_KEY =
  "missing-merchant-data-popup-dismissed";

const MissingPaymentInfoModal = NiceModal.create(() => {
  const { t } = useTranslation();
  const router = useRouter();

  const [isLoading, setIsLoading] = useState(false);

  const { save } = useStorage("session");
  const modal = useModal();

  const handleClose = () => {
    modal.resolve();
    modal.hide();
  };

  const handleClick = async () => {
    setIsLoading(true);

    try {
      save(MISSING_PAYMENT_INFO_STORAGE_KEY, true);
      await router.push("/account/settings/payment");
      handleClose();
    } catch (ex) {
      console.log("PaymentsOverlay:handleClick", ex);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open={modal.visible}
      icon={<IconStateSecurity className="size-5 shrink-0 text-brand-500" />}
      title={t("account-payment:my-payments-incomplete-info-title")}
      onClose={handleClose}
    >
      <div className="flex flex-col items-center gap-[16px]">
        <Body className="max-w-96 text-center">
          {t("account-payment:my-payments-incomplete-info")}
        </Body>
        <Button loading={isLoading} onClick={handleClick}>
          {t("account-payment:my-payments-incomplete-button")}
        </Button>
      </div>
    </Modal>
  );
});

export default MissingPaymentInfoModal;
